// extracted by mini-css-extract-plugin
export default {"modalWrap":"ModalWrap_modalWrap__I8bpJ","tabletSmallSize":"ModalWrap_tabletSmallSize__Ntju6"};